import { render, staticRenderFns } from "./CommentAuditPanel.vue?vue&type=template&id=70594a72&scoped=true"
import script from "./CommentAuditPanel.vue?vue&type=script&lang=js"
export * from "./CommentAuditPanel.vue?vue&type=script&lang=js"
import style0 from "./CommentAuditPanel.vue?vue&type=style&index=0&id=70594a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70594a72",
  null
  
)

export default component.exports